import type { FC } from "react";

import { VideoPlayer } from "@ui/components/VideoPlayer/VideoPlayer";
import classNames from "classnames";

import type { BannerContainerType } from "./BannerContainer";
import { BannerContainer } from "./BannerContainer";

import "./Hero.scss";

type Override<T1, T2> = Omit<T1, keyof T2> & T2;
export type HeroProps = Override<
  BannerContainerType,
  {
    img: string;
    mobileImg: string;
    isVideo?: boolean;
    videoMobile?: string;
    videoTablet?: string;
    videoDesktop?: string;
    fullscreen?: boolean;
    containerClassName?: string;
    bannerContainerClassName?: string;
  }
>;

/**
 *
 * Hero v1 component used in Loyalty
 * @deprecated use HeroV2 instead
 */
export const Hero: FC<HeroProps> = ({
  img,
  mobileImg,
  bottomMobileImg,
  headerContent,
  loggedTitle,
  unloggedTitle,
  loggedContent,
  unloggedContent,
  isLogged,
  fullscreen = true,
  isVideo = false,
  videoMobile,
  videoTablet,
  videoDesktop,
  containerClassName,
  bannerContainerClassName,
}: HeroProps) => {
  const containerClass = classNames("hero", containerClassName, {
    "hero--logged": isLogged,
    "hero--not-fullscreen": !fullscreen,
  });

  const bannerContainerProps: BannerContainerType = {
    bottomMobileImg,
    fullscreen,
    headerContent,
    isLogged,
    loggedTitle,
    unloggedTitle,
    loggedContent,
    unloggedContent,
    className: bannerContainerClassName,
  };

  const mobileBackgroundContainer = classNames("hero__img", "hero__imgMobile");

  if (!isVideo) {
    const backgroundStyle: React.CSSProperties = {
      backgroundImage: `url(${img})`,
    };
    return (
      <div className={containerClass} style={backgroundStyle} data-testid="hero-banner">
        <div className={mobileBackgroundContainer} data-testid="hero__mobile-background-container">
          <img src={mobileImg} alt={""} />
        </div>
        <BannerContainer {...bannerContainerProps} />
      </div>
    );
  }

  return (
    <div className={containerClass} data-testid="hero-banner">
      <VideoPlayer
        preventDownload={true}
        showControls={false}
        preventMainPlayButtonClick={true}
        loop={true}
        autoPlay={true}
        mobileSrc={videoMobile}
        tabletSrc={videoTablet}
        desktopSrc={videoDesktop || ""}
      />
      <BannerContainer {...bannerContainerProps} />
    </div>
  );
};
